import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Alert,
  Breadcrumb,
  Button,
  Card,
  Col,
  Divider,
  notification,
  Popconfirm,
  Row,
  Spin,
  Typography,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { CheckOutlined } from '@ant-design/icons';
import { useGetSubscriptionMutation } from '../slices/subscriptionApiSlice';
import { setSubscriptions } from '../slices/subscriptionSlice';
import { useGetSubMutation } from '../slices/usersApiSlice';
import moment from 'moment-timezone';
import "../screens/css/subscription.css"
const SubscriptionScreen = () => {
  moment.tz.setDefault("Asia/Calcutta|Asia/Kolkata");
  const [api, contextHolder] = notification.useNotification();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const { darkmode } = useSelector((state) => state.darkmode);
  const { subscription } = useSelector((state) => state.subscription);
  const [getSubscription, { isLoading: isSubLoading }] = useGetSubscriptionMutation();
  const [getmySub, { isLoading: ismyLoading }] = useGetSubMutation();
  const [currentPlan, setCurrentPlan] = useState(null);
  const [subid, setSubid] = useState(null);
  const [loading, setLoading] = useState(true);
  const [btloading, setBtloading] = useState(false);
  const [loadingPlanId, setLoadingPlanId] = useState(null);
  const [autoPay, setAutoPay] = useState(null); // user's AutoPay record (has the Razorpay subscription id)
  const [cancelling, setCancelling] = useState(false);

  const { Title, Text } = Typography;

  const getSubscriptiondata = async () => {
    try {
      const res = await getSubscription().unwrap();
      dispatch(setSubscriptions({ ...res }));
    } catch (err) {
      api.error({
        message: err?.data?.message || err.error || err?.data?.error || err?.data?.error,
      });
    }
  };

  const fetchAutoPay = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/v1/autopay/subscription`,
        { withCredentials: true }
      );
      setAutoPay(data?.hasAutoPay ? data.subscription : null);
    } catch (e) {
      setAutoPay(null);
    }
  };

  const cancelStatuses = ['CANCELLED', 'COMPLETED', 'EXPIRED'];
  const canCancelAutoPay =
    !!autoPay?.razorpaySubscriptionId &&
    !autoPay?.cancelAtCycleEnd &&
    !cancelStatuses.includes(String(autoPay.status || '').toUpperCase());
  // normal (one-time) plan that is active and not an AutoPay one
  const canCancelNormal =
    currentPlan?.status === 'active' && currentPlan?.paymentMode !== 'AUTOPAY' && !canCancelAutoPay;
  const canCancel = canCancelAutoPay || canCancelNormal;

  const handleCancelSubscription = async () => {
    setCancelling(true);
    try {
      if (!canCancelAutoPay) {
        // normal plan: switched off right away
        await axios.post(
          `${process.env.REACT_APP_BACKEND_URI}/api/v1/auth/cancel-subscription`,
          {},
          { withCredentials: true }
        );
        api.success({ message: 'Subscription cancelled' });
        await getMysub();
        return;
      }

      // an ACTIVE plan stays usable until the paid period ends; one that was never charged is cancelled right away
      const isActive = String(autoPay.status || '').toUpperCase() === 'ACTIVE';
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/v1/autopay/cancel`,
        { subscriptionId: autoPay.razorpaySubscriptionId, cancelAtCycleEnd: isActive },
        { withCredentials: true }
      );
      api.success({
        message: 'Subscription cancelled',
        description: isActive
          ? 'AutoPay is off. Your plan stays active until the end of the current billing period.'
          : data?.message,
      });
      await getMysub();
    } catch (err) {
      api.error({
        message: 'Unable to cancel subscription',
        description: err?.response?.data?.message || err?.message,
      });
    } finally {
      setCancelling(false);
    }
  };

  const getMysub = async () => {
    fetchAutoPay();
    try {
      const res = await getmySub().unwrap();
      setCurrentPlan(res.subscription);
      setSubid(res.subid);
    } catch (err) {
      api.error({
        message: err?.data?.message || err.error || err?.data?.error || err?.data?.error,
      });
    }
  };

  useEffect(() => {
    getSubscriptiondata();
    getMysub();
  }, []);

  // const checkoutHandler = async (amount, name, id) => {
  //   setBtloading(true);
  //   axios.defaults.withCredentials = true;

  //   const { data: { key } } = await axios.post(`${process.env.REACT_APP_BACKEND}/api/v1/payment/getkey`);
  //   const { data: { order } } = await axios.post(`${process.env.REACT_APP_BACKEND}/api/v1/payment/checkout`, {
  //     amount, id
  //   });

  //   const options = {
  //     key: key,
  //     amount: order.amount,
  //     currency: "INR",
  //     name: name,
  //     description: "Lincfolio Subscription Plan",
  //     image: "http://localhost:3000/logo.png",
  //     order_id: order.id,
  //     callback_url:` ${process.env.REACT_APP_BACKEND}/api/v1/payment/paymentverification`,
  //     prefill: {
  //       name: userInfo.firstname + ' ' + userInfo.lastname,
  //       email: userInfo.email,
  //     },
  //     theme: {
  //       color: "#2f3640"
  //     }
  //   };
  //   const razor = new window.Razorpay(options);
  //   razor.open();
  //   setBtloading(false);
  // };

  const checkoutHandler = async (amount, name, id) => {
    setLoadingPlanId(id); // set loading for that specific plan
    try {
      axios.defaults.withCredentials = true;

      const { data: { key } } = await axios.post(`${process.env.REACT_APP_BACKEND_URI}/api/v1/payments/getkey`);
      const { data: { order } } = await axios.post(`${process.env.REACT_APP_BACKEND_URI}/api/v1/payments/checkout`, {
        amount, planId:id
      });

      const options = {
        key: key,
        amount: order.amount,
        currency: "INR",
        name: name,
        description: "Lincfolio Subscription Plan",
        image: "https://testapp.lincfolio.com//logo.png",
        order_id: order.id,
        callback_url: ` ${process.env.REACT_APP_BACKEND_URI}/api/v1/payments/paymentverification`,
        prefill: {
          name: userInfo.firstname + ' ' + userInfo.lastname,
          email: userInfo.email,
        },
        theme: {
          color: "#2f3640"
        }
      };
      const razor = new window.Razorpay(options);
      razor.open();
    } catch (error) {
      notification.error({ message: 'Subscription failed' });
    } finally {
      setLoadingPlanId(null);
    }
  };


const autopayCheckoutHandler = async (plan) => {
  console.log("[AutoPay] 1. Checkout started", {
    planId: plan?.id,
    planName: plan?.name,
  });

  setLoadingPlanId(plan.id);

  try {
    const backendURI = process.env.REACT_APP_BACKEND_URI;

    console.log("[AutoPay] 2. Backend URL:", backendURI);

    if (!backendURI) {
      throw new Error("Backend URL is not configured");
    }

    console.log("[AutoPay] 3. Creating subscription...");

    const { data } = await axios.post(
      `${backendURI}/api/v1/autopay/create`,
      { planId: plan.id },
      { withCredentials: true }
    );

    console.log("[AutoPay] 4. Create API response:", {
      success: data?.success,
   subscriptionId: data?.subscriptionId,
      razorpayKeyReceived: Boolean(data?.razorpayKey),
      message: data?.message,
    });

    if (
      !data.success ||
      !data.subscriptionId ||
      !data.razorpayKey
    ) {
      throw new Error(
        data.message || "Invalid AutoPay subscription response"
      );
    }

    if (!window.Razorpay) {
      throw new Error("Razorpay Checkout script is not loaded");
    }

    const razor = new window.Razorpay({
      key: data.razorpayKey,
      subscription_id: data.subscriptionId,
      name: "Lincfolio",
      description: `${plan.name} - AutoPay Subscription`,

      prefill: {
        name: `${userInfo?.firstname || ""} ${
          userInfo?.lastname || ""
        }`.trim(),
        email: userInfo?.email || "",
      },

      theme: { color: "#CB9E52" },

      handler: async (response) => {
        console.log("[AutoPay] 5. Checkout handler fired");
        console.log("[AutoPay] 6. Checkout response fields:", {
          paymentIdReceived: Boolean(
            response?.razorpay_payment_id
          ),
          subscriptionIdReceived: Boolean(
            response?.razorpay_subscription_id
          ),
          signatureReceived: Boolean(
            response?.razorpay_signature
          ),
        });

        try {
          if (
            !response?.razorpay_payment_id ||
            !response?.razorpay_subscription_id ||
            !response?.razorpay_signature
          ) {
            throw new Error(
              "Checkout response is missing required verification fields"
            );
          }

          const verificationURL =
            `${backendURI}/api/v1/autopay/verification`;

          console.log("[AutoPay] 7. Calling verification API:", {
            url: verificationURL,
            subscriptionId: response.razorpay_subscription_id,
            paymentIdReceived: true,
          });

          const verification = await axios.post(
            verificationURL,
            {
              razorpay_payment_id:
                response.razorpay_payment_id,
              razorpay_subscription_id:
                response.razorpay_subscription_id,
              razorpay_signature:
                response.razorpay_signature,
            },
            { withCredentials: true }
          );

          console.log("[AutoPay] 8. Verification HTTP status:",
            verification.status
          );

          console.log("[AutoPay] 9. Verification API response:", {
            success: verification.data?.success,
            message: verification.data?.message,
          });

          if (!verification.data?.success) {
            throw new Error(
              verification.data?.message ||
                "AutoPay verification failed"
            );
          }

          console.log("[AutoPay] 10. Verification successful");

          api.success({
            message: "AutoPay authorization submitted",
            description:
              "Verification succeeded. Subscription activation depends on the confirmed Razorpay status.",
          });

          console.log("[AutoPay] 11. Refreshing subscription...");
          await getMysub();
          console.log("[AutoPay] 12. Subscription refresh finished");
        } catch (error) {
          console.error("[AutoPay] Verification error:", {
            message: error?.message,
            httpStatus: error?.response?.status,
            responseData: error?.response?.data,
          });

          api.error({
            message: "Verification failed",
            description:
              error?.response?.data?.message ||
              error?.message ||
              "Verification request failed",
          });
        } finally {
          setLoadingPlanId(null);
        }
      },

      modal: {
        ondismiss: () => {
          console.warn("[AutoPay] Checkout dismissed");
          setLoadingPlanId(null);
        },
      },
    });

    razor.on("payment.failed", (response) => {
      // console.error("[AutoPay] Razorpay payment failed:", {
      //   code: response?.error?.code,
      //   description: response?.error?.description,
      //   reason: response?.error?.reason,
      // });
  console.error(
    "[AutoPay] Error details:",
    JSON.stringify(response.error, null, 2)
  );
      setLoadingPlanId(null);
    });
    

    console.log("[AutoPay] 4.1 Opening Razorpay Checkout");
    razor.open();
  } catch (error) {
    console.error("[AutoPay] Subscription creation/checkout error:", {
      message: error?.message,
      httpStatus: error?.response?.status,
      responseData: error?.response?.data,
    });

    api.error({
      message: "Unable to start AutoPay",
      description:
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong",
    });

    setLoadingPlanId(null);
  }
};




const handleSubscribe = (plan) => {
  // Free plan: no Razorpay checkout
  if (Number(plan.price) === 0) {
    // Call your existing free-plan activation API here.
    // Do not send the user to paid checkout.
    api.info({
      message: "Free plan selected",
      description: "Connect your free-plan activation API here.",
    });
    return;
  }

  // Recurring payment
  if (plan.autopay === true) {
    autopayCheckoutHandler(plan);
    return;
  }

  // Existing one-time payment flow
  checkoutHandler(plan.price, plan.name, plan.id);
};








return (
  <div className="glass-scope subscription-page">
    {contextHolder}

    <Row>
      <Col flex="auto">
        <Breadcrumb
          items={[
            { title: "Dashboard" },
            { title: "My Subscriptions" },
          ]}
          className="subscription-breadcrumb"
        />
      </Col>
    </Row>

    <Divider />

    {ismyLoading ? (
      <Spin tip="Loading current subscription...">
        <div style={{ height: "200px" }} />
      </Spin>
    ) : (
      <>
        {currentPlan && currentPlan.status !== "deactive" ? (
          <Alert
            className="subscription-alert"
            message={`You are currently subscribed to the ${subid?.name}`}
            description={`Status: ${currentPlan.status} | Next Billing Date: ${moment(
              currentPlan.endDate
            ).format("DD-MMM-YYYY")}`}
            type="success"
            showIcon
            action={
              canCancel && (
                <Popconfirm
                  title="Cancel your subscription?"
                  description={
                    canCancelAutoPay
                      ? "AutoPay will stop and you won't be charged again."
                      : 'Your plan will be switched off immediately.'
                  }
                  okText="Yes, cancel"
                  cancelText="Keep it"
                  okButtonProps={{ danger: true, loading: cancelling }}
                  onConfirm={handleCancelSubscription}
                >
                  <Button danger loading={cancelling}>
                    Cancel subscription
                  </Button>
                </Popconfirm>
              )
            }
          />
        ) : (
          <Alert
            className="subscription-alert"
            message="You are not currently subscribed to any plan."
            type="warning"
            showIcon
          />
        )}

        <Divider orientation="left" className="subscription-section-divider">
          Available Plans
        </Divider>

        <Row gutter={[16, 16]}>
          {subscription != null &&
            subscription.map((plan) => {
              const isCurrentPlan =
                currentPlan?.plan_id?.toString() ===
                plan.id?.toString();

              return (
                <Col xs={24} sm={12} md={8} lg={8} key={plan._id || plan.name}>
                  <Card
                    className={`glass-card subscription-plan-card ${
                      isCurrentPlan
                        ? "subscription-plan-card--current"
                        : ""
                    }`}
                    bordered={false}
                    bodyStyle={{
                      display: "flex",
                      flexDirection: "column",
                      flex: 1,
                      height: "100%",
                      padding: "24px",
                    }}
                  >
                    <div className="subscription-plan-content">
                      {plan?.popular && (
                        <div className="subscription-popular-ribbon">
                          POPULAR
                        </div>
                      )}

                      <div className="subscription-plan-name">
                        {plan.name}
                      </div>

                      <div className="subscription-plan-price">
                        ₹ {plan.price}
                      </div>

                      <div className="subscription-payment-mode">
                        <span
                          className={`subscription-payment-badge ${
                            plan.autopay
                              ? "subscription-payment-badge--autopay"
                              : "subscription-payment-badge--onetime"
                          }`}
                        >
                          <span>{plan.autopay ? "↻" : "✓"}</span>
                          {plan.autopay
                            ? "AUTOPAY"
                            : "ONE-TIME PAYMENT"}
                        </span>
                      </div>

                      <div className="subscription-highlights">
                        {plan?.highlights?.map((item, index) => (
                          <React.Fragment key={index}>
                            <div
                              className={`subscription-highlight ${
                                index === 1
                                  ? "subscription-highlight--featured"
                                  : ""
                              }`}
                            >
                              {item}
                            </div>

                            {index !== plan.highlights.length - 1 && (
                              <div className="subscription-highlight-divider" />
                            )}
                          </React.Fragment>
                        ))}
                      </div>
                    </div>

                    <div className="subscription-plan-actions">
                      {isCurrentPlan ? (
                        <Button
                          icon={<CheckOutlined />}
                          disabled
                          className="gold-btn subscription-action-button"
                        >
                          CURRENT PLAN
                        </Button>
                      ) : (
                        <Button
                          type="primary"
                          className="gold-btn subscription-action-button"
                          loading={loadingPlanId === plan._id}
                          disabled={loadingPlanId !== null}
                          onClick={() => handleSubscribe(plan)}
                        >
                          {plan.autopay
                            ? "START AUTOPAY"
                            : Number(plan.price) === 0
                              ? "SUBSCRIBE FOR FREE"
                              : "SUBSCRIBE"}
                        </Button>
                      )}
                    </div>
                  </Card>
                </Col>
              );
            })}
        </Row>
      </>
    )}
  </div>
);

};

export default SubscriptionScreen;